(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8925],{

/***/ 18919:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magnets-cto",
      function () {
        return __webpack_require__(50190);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 40176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ HashAnchor; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
;// CONCATENATED MODULE: ./components/HashAnchor/HashAnchor.contants.ts
// Constants.
// -----------------------------------------------------------------------------
var DEFAULT_TOP_MARGIN_IN_PIXELS = -50;

;// CONCATENATED MODULE: ./components/HashAnchor/HashAnchor.tsx



var HashAnchor = function(param) {
    var name = param.name, _top = param.top, top = _top === void 0 ? DEFAULT_TOP_MARGIN_IN_PIXELS : _top;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
        name: name,
        id: name,
        style: {
            position: "relative",
            top: "".concat(top, "px"),
            display: "block",
            visibility: "hidden"
        }
    });
};

;// CONCATENATED MODULE: ./components/HashAnchor/index.ts



/***/ }),

/***/ 2991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ FormSelect; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
// EXTERNAL MODULE: ./components/shared/Select.tsx
var Select = __webpack_require__(2679);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
;// CONCATENATED MODULE: ./components/form/FormSelect/FormSelect.tsx






var FormSelect = function(param) {
    var name = param.name, options = param.options, _formGroup = param.formGroup, formGroup = _formGroup === void 0 ? {} : _formGroup, _input = param.input, input = _input === void 0 ? {} : _input;
    var ref, ref1;
    var ref2 = (0,index_esm/* useFormContext */.Gc)(), control = ref2.control, errors = ref2.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formGroup), {
        error: errors === null || errors === void 0 ? void 0 : (ref = errors[name]) === null || ref === void 0 ? void 0 : (ref1 = ref.message) === null || ref1 === void 0 ? void 0 : ref1.toString(),
        forId: name,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            control: control,
            name: name,
            render: function(param) {
                var field = param.field;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Select/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    id: name,
                    options: options,
                    type: "text",
                    variant: (errors === null || errors === void 0 ? void 0 : errors[name]) ? "error" : ""
                }, input, field), {
                    value: field.value || ""
                }));
            }
        })
    }));
};

;// CONCATENATED MODULE: ./components/form/FormSelect/index.ts



/***/ }),

/***/ 78712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FormText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_HashAnchor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40176);
/* harmony import */ var components_shared_FormGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74993);
/* harmony import */ var components_shared_InputText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6776);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63955);







var FormText = function(param) {
    var name = param.name, _formGroup = param.formGroup, formGroup = _formGroup === void 0 ? {} : _formGroup, _input = param.input, input = _input === void 0 ? {} : _input;
    var ref, ref1;
    var ref2 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useFormContext */ .Gc)(), control = ref2.control, errors = ref2.formState.errors;
    var onChangeHandler = input.onChange || function() {
    // NOOP
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_FormGroup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, formGroup), {
        error: errors === null || errors === void 0 ? void 0 : (ref = errors[name]) === null || ref === void 0 ? void 0 : (ref1 = ref.message) === null || ref1 === void 0 ? void 0 : ref1.toString(),
        forId: name,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .Controller */ .Qr, {
            control: control,
            name: name,
            render: function(param) {
                var field = param.field;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HashAnchor__WEBPACK_IMPORTED_MODULE_1__/* .HashAnchor */ .v, {
                            name: "anchor_".concat(name)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_InputText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            id: name,
                            "aria-label": name,
                            type: "text",
                            variant: (errors === null || errors === void 0 ? void 0 : errors[name]) ? "error" : ""
                        }, input, field), {
                            onChange: function(e) {
                                field.onChange(e);
                                onChangeHandler(e);
                            }
                        }))
                    ]
                });
            }
        })
    }));
};


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 23793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* reexport safe */ _useToasts__WEBPACK_IMPORTED_MODULE_0__.e; }
/* harmony export */ });
/* harmony import */ var _useToasts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57064);



/***/ }),

/***/ 50190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ magnets_cto; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs
var zod = __webpack_require__(33161);
// EXTERNAL MODULE: ./components/form/FormSelect/index.ts + 1 modules
var FormSelect = __webpack_require__(2991);
// EXTERNAL MODULE: ./components/form/FormText/FormText.tsx
var FormText = __webpack_require__(78712);
// EXTERNAL MODULE: ./components/HashAnchor/index.ts + 2 modules
var HashAnchor = __webpack_require__(40176);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/shared/Checkbox.tsx
var Checkbox = __webpack_require__(68341);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/LinkText.tsx
var LinkText = __webpack_require__(23405);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./hooks/useToasts/index.ts
var useToasts = __webpack_require__(23793);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./services/service.lead.ts
var service_lead = __webpack_require__(67075);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/errors.ts
var errors = __webpack_require__(31386);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./features/magnets/cto/MagnetCTOPage.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url('/images/magnets-bg.svg') no-repeat 0 100%;\n  background-size: 25%;\n  padding-bottom: 200px;\n\n  @media (max-width: 768px) {\n    background: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: -6rem auto 0 auto;\n  padding: 2rem;\n  line-height: 1.5;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: 0 auto;\n  flex: 1 1 auto;\n  padding: 4rem 2rem 2rem 2rem;\n  display: flex;\n  gap: 4rem;\n\n  .success,\n  .form {\n    flex: 1 1 55%;\n  }\n\n  .success {\n    color: #837e93;\n    text-align: center;\n    width: 85%;\n    align-self: flex-end;\n\n    h2 {\n      line-height: 1.2;\n      margin: 0;\n    }\n\n    p {\n      color: #333;\n    }\n\n    svg {\n      color: #78d549;\n    }\n  }\n\n  .content {\n    > .wrapper {\n      background: url('/images/magnets-cto-bg.png') no-repeat 0 100%;\n      background-size: 100%;\n      padding-bottom: 300px;\n    }\n\n    flex: 1 1 45%;\n\n    h2 {\n      line-height: 1.2;\n      margin: 0;\n    }\n\n    p {\n      margin-top: 0;\n    }\n  }\n\n  @media (max-width: 768px) {\n    background: none;\n    flex-direction: column;\n\n    .form,\n    .content {\n      flex: 0 0 auto;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledWrapperBG = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-405b94f1-0"
})(_templateObject());
var StyledMktText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-405b94f1-1"
})(_templateObject1(), (0,theme/* container */.nC)("md"));
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-405b94f1-2"
})(_templateObject2(), (0,theme/* container */.nC)("xl"));

// EXTERNAL MODULE: ../utils/dist/esm/index.js + 3 modules
var esm = __webpack_require__(74679);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ./features/magnets/cto/MagnetCTOPage.types.ts


var MagnetOnboardingFormSchema = lib.z.object({
    reason: lib.z.string(),
    fullName: lib.z.string().nonempty("common:required-message").min(2, "common:form.min-length-2"),
    email: lib.z.string().nonempty("common:required-message").min(2, "common:form.min-length-2"),
    company: lib.z.string().nonempty("common:required-message").min(2, "common:form.min-length-2")
}).refine(function(schema) {
    var ref;
    return (ref = schema.email) === null || ref === void 0 ? void 0 : ref.match(esm/* EMAIL_REGEX */.CU);
}, {
    path: [
        "email"
    ],
    message: "common:form.invalid-email"
});

// EXTERNAL MODULE: ../../node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(17473);
;// CONCATENATED MODULE: ./features/magnets/cto/MagnetCTOPage.tsx



























var MagnetCTOPage = function() {
    var t = (0,useI18n/* useI18n */.Q)("magnets").t;
    var addErrorToast = (0,useToasts/* useToasts */.e)().addErrorToast;
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var ref = (0,react.useState)(false), isSubmitted = ref[0], setIsSubmitted = ref[1];
    var ref1 = (0,react.useState)(false), terms = ref1[0], setTerms = ref1[1];
    var ref2 = (0,react.useState)(false), accept = ref2[0], setAccept = ref2[1];
    var formMethods = (0,index_esm/* useForm */.cI)({
        mode: "onBlur",
        defaultValues: {
            fullName: "",
            email: "",
            company: ""
        },
        resolver: (0,zod/* zodResolver */.F)(MagnetOnboardingFormSchema)
    });
    var reason = formMethods.watch("reason");
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var recaptchaToken, ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!executeRecaptcha) {
                            console.error("Recaptcha not available");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            executeRecaptcha("magnets_cto_submit")
                        ];
                    case 1:
                        recaptchaToken = _state.sent();
                        service_lead/* ServiceLead.create */.W.create({
                            clientName: data.fullName,
                            contactEmail: data.email,
                            companyName: data.company,
                            landingName: "magnets-cto",
                            isMql: data.reason === "1" || data.reason === "2",
                            createPipedriveLead: data.reason === "1" || data.reason === "2",
                            isSubscribeToNewsletter: true,
                            recaptchaToken: recaptchaToken
                        });
                        setIsSubmitted(true);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        ex = _state.sent();
                        console.error("[MagnetCTOPage] Could not send form data. ".concat(ex));
                        addErrorToast(t("magnets.cto.form.submit-error", {
                            error: (0,errors/* getErrorMessage */.e)(ex)
                        }));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addErrorToast,
        t,
        executeRecaptcha
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        pageVariant: "midnight_light",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapperBG, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                            direction: "column",
                            gap: "s",
                            className: "content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                direction: "column",
                                gap: "s",
                                className: "wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xv, {
                                        bold: true,
                                        uppercase: true,
                                        size: "s",
                                        children: t("magnets.cto.content.sub-title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                        as: "h2",
                                        size: "4xl",
                                        children: t("magnets.cto.content.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                        ns: "magnets",
                                        i18nKey: "magnets.cto.content.desc"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                            className: "form",
                            children: !isSubmitted ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formMethods), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HashAnchor/* HashAnchor */.v, {
                                        name: "form"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                        onSubmit: formMethods.handleSubmit(onSubmit),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                            direction: "column",
                                            gap: "4xl",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                                    name: "fullName",
                                                    formGroup: {
                                                        label: t("magnets.cto.form.full-name.label")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                                    name: "email",
                                                    formGroup: {
                                                        label: t("magnets.cto.form.email.label")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormText/* FormText */.R, {
                                                    name: "company",
                                                    formGroup: {
                                                        label: t("magnets.cto.form.company.label")
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* FormSelect */.i, {
                                                    name: "reason",
                                                    formGroup: {
                                                        label: t("magnets.cto.form.reason")
                                                    },
                                                    options: [
                                                        {
                                                            label: t("magnets.cto.form.reason0"),
                                                            value: "0"
                                                        },
                                                        {
                                                            label: t("magnets.cto.form.reason1"),
                                                            value: "1"
                                                        },
                                                        {
                                                            label: t("magnets.cto.form.reason2"),
                                                            value: "2"
                                                        },
                                                        {
                                                            label: t("magnets.cto.form.reason3"),
                                                            value: "3"
                                                        },
                                                        {
                                                            label: t("magnets.cto.form.reason4"),
                                                            value: "4"
                                                        }
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    id: "accept",
                                                    checked: accept,
                                                    onChange: function() {
                                                        return setAccept(function(prev) {
                                                            return !prev;
                                                        });
                                                    },
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                        ns: "magnets",
                                                        i18nKey: "magnets.cto.form.privacy.label"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    id: "terms",
                                                    checked: terms,
                                                    onChange: function() {
                                                        return setTerms(function(prev) {
                                                            return !prev;
                                                        });
                                                    },
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                        ns: "magnets",
                                                        i18nKey: "magnets.cto.form.terms.label",
                                                        components: {
                                                            termsLink: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.termsOfUse */.uu.termsOfUse),
                                                                target: "_blank"
                                                            }),
                                                            privacyLink: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.privacyPolicy */.uu.privacyPolicy),
                                                                target: "_blank"
                                                            })
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        display: "none"
                                                    },
                                                    children: [
                                                        formMethods.formState.isValid ? "valid: true" : "valid: false",
                                                        terms ? "terms: true" : "terms: false"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* StackItem */.vO, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
                                                        label: t("magnets.cto.form.submit"),
                                                        schema: "brand2",
                                                        startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k,
                                                        size: "xs",
                                                        isLoading: formMethods.formState.isSubmitting,
                                                        disabled: !terms || !accept || !formMethods.formState.isValid || reason === "0"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Stack */.Kq, {
                                direction: "column",
                                className: "success",
                                alignment: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                        icon: pro_light_svg_icons/* faCheckCircle */.f8k,
                                        size: "6xl"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                                        as: "h2",
                                        size: "2xl",
                                        children: t("magnets.cto.success.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xv, {
                                        bold: true,
                                        size: "l",
                                        children: t("magnets.cto.success.sub-title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                        ns: "magnets",
                                        i18nKey: "magnets.cto.success.desc",
                                        components: {
                                            teamLink: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:team@getmanfred.com",
                                                target: "_blank"
                                            })
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMktText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xv, {
                        bold: true,
                        uppercase: true,
                        size: "s",
                        children: t("magnets.cto.content.sub-title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Header */.h4, {
                        as: "h2",
                        size: "2xl",
                        children: t("magnets.cto.mkt.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "magnets",
                            i18nKey: "magnets.cto.mkt.desc"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                        to: "form",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                            label: t("magnets.cto.form.submit"),
                            schema: "brand2",
                            variant: "hard",
                            startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k,
                            size: "xs"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/magnets/cto/index.ts


// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./pages/magnets-cto.tsx







var MangetsCTOPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("magnets").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                url: app_urls/* APP_URLS.magnetsCTO */.uu.magnetsCTO,
                title: t("magnets.cto.page-title"),
                desc: t("magnets.cto.page-description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_magnets_cto.png"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MagnetCTOPage, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var magnets_cto = (MangetsCTOPage);


/***/ }),

/***/ 67075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ServiceLead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22970);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3818);
/* harmony import */ var utils_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89608);




/**
 * Service to interact with Manfred public Lead
 */ var ServiceLead = {
    /**
   * Create a new Lead for Manfred
   *
   * @param leadInfo Info to create the new lead
   */ create: function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(dealInfo) {
            var url;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                url = (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .getApiPathUrl */ .P)("/v2/public/ui/leads");
                return [
                    2,
                    utils_fetch__WEBPACK_IMPORTED_MODULE_1__/* .post */ .v_("".concat(url), dealInfo)
                ];
            });
        });
        return function(dealInfo) {
            return _ref.apply(this, arguments);
        };
    }()
};


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ }),

/***/ 74679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CU": function() { return /* reexport */ EMAIL_REGEX; },
  "pv": function() { return /* reexport */ GITHUB_URL_OR_EMPTY_REGEX; },
  "f5": function() { return /* reexport */ LINKEDIN_PROFILE_URL_OR_EMPTY_REGEX; },
  "oS": function() { return /* reexport */ SO_DEV_STORY_URL_REGEX; },
  "_B": function() { return /* reexport */ SO_URL_OR_EMPTY_REGEX; },
  "x5": function() { return /* reexport */ TWITTER_URL_OR_EMPTY_REGEX; },
  "Yl": function() { return /* reexport */ URL_OR_EMPTY_REGEX; },
  "Cx": function() { return /* reexport */ isValidGitHubURL; },
  "_C": function() { return /* reexport */ isValidSOURL; },
  "pn": function() { return /* reexport */ isValidTwitterURL; },
  "T6": function() { return /* reexport */ isValidURLOrEmpty; }
});

// UNUSED EXPORTS: CURRENCY_LIST, GITHUB_URL_REGEX, LINKEDIN_IMAGE_URL_REGEX, LINKEDIN_PROFILE_URL_REGEX, MANFREDITE_PROFILE_SLUG_URL_OR_EMPTY_REGEX, MANFREDITE_PROFILE_URL_OR_EMPTY_REGEX, MANFREDITE_PROFILE_URL_REGEX, SO_URL_REGEX, TWITTER_URL_REGEX, URL_REGEX, extractLastUrlSegment, getFakeAvatarUrl, getLinkedinUsernameFromUrl, getSecondsBetweenDates, getSecondsUntilNow, getWeekNumber, isValidDevStorySOURL, isValidLinkedinImageUrl, isValidLinkedinUrl, isValidManfrediteProfileUrl, isValidURL

;// CONCATENATED MODULE: ../utils/dist/esm/data/index.js
const CURRENCY_LIST = [
    {
        label: 'currency.euro',
        value: '€'
    },
    {
        label: 'currency.usdollar',
        value: 'US$'
    },
    {
        label: '----------------',
        value: ''
    },
    {
        label: 'currency.australiandollar',
        value: 'A$'
    },
    {
        label: 'currency.canadiandollar',
        value: 'C$'
    },
    {
        label: 'currency.hongkongdollar',
        value: 'HK$'
    },
    {
        label: 'currency.japaneseyen',
        value: '¥'
    },
    {
        label: 'currency.mexicanpeso',
        value: 'MXN$'
    },
    {
        label: 'currency.pundsterling',
        value: '£'
    },
    {
        label: 'currency.renminbi',
        value: 'CNY'
    },
    {
        label: 'currency.russianruble',
        value: '₽'
    },
    {
        label: 'currency.singaporedollar',
        value: 'S$'
    },
    {
        label: 'currency.swedishkrona',
        value: 'SEK'
    },
    {
        label: 'currency.argentinianpeso',
        value: 'ARS$'
    },
    {
        label: 'currency.brizilianreal',
        value: 'R$'
    },
    {
        label: 'currency.chileanpeso',
        value: 'CLP$'
    },
    {
        label: 'currency.colombianpeso',
        value: 'COL$'
    },
    {
        label: 'currency.czechkoruna',
        value: 'Kč'
    },
    {
        label: 'currency.danishkrone',
        value: 'DKK'
    },
    {
        label: 'currency.israelinewshekel',
        value: '₪'
    },
    {
        label: 'currency.norwegiankrone',
        value: 'NOK'
    },
    {
        label: 'currency.polishzloti',
        value: 'zł'
    },
    {
        label: 'currency.swissfranc',
        value: 'CHF'
    }
];
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../utils/dist/esm/validation/index.js
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const URL_REGEX = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;
const URL_OR_EMPTY_REGEX = /^$|(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;
const SO_DEV_STORY_URL_REGEX = /^https:\/\/(www\.)?stackoverflow\.com\/(story|cv|users\/story)\/(.)+$/i;
function isValidDevStorySOURL(url) {
    return SO_DEV_STORY_URL_REGEX.test(url);
}
const SO_URL_REGEX = /^https:\/\/(www\.)?stackoverflow\.com\/users\/(.)+$/i;
const SO_URL_OR_EMPTY_REGEX = /^$|https:\/\/(www\.)?stackoverflow\.com\/users\/(.)+$/i;
function isValidSOURL(url) {
    return SO_URL_REGEX.test(url);
}
const TWITTER_URL_REGEX = /^https:\/\/(www\.)?(twitter\.com|x\.com)\/(.)+$/i;
const TWITTER_URL_OR_EMPTY_REGEX = /^$|https:\/\/(www\.)?(twitter\.com|x\.com)\/(.)+$/i;
function isValidTwitterURL(url) {
    return TWITTER_URL_REGEX.test(url);
}
const GITHUB_URL_REGEX = /^https:\/\/(www\.)?github\.com\/(.)+$/i;
const GITHUB_URL_OR_EMPTY_REGEX = /^$|https:\/\/(www\.)?github\.com\/(.)+$/i;
function isValidGitHubURL(url) {
    return GITHUB_URL_REGEX.test(url);
}
function isValidURL(url) {
    return URL_REGEX.test(url);
}
function isValidURLOrEmpty(url) {
    return URL_OR_EMPTY_REGEX.test(url);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../utils/dist/esm/linkedin/linkedin-utils.js
const LINKEDIN_PROFILE_URL_REGEX = /^(https:\/\/)?(\S{2,4}\.)?linkedin.com\/in\/([^?/\s]+)[/]?$/i;
const LINKEDIN_IMAGE_URL_REGEX = /^(https:\/\/)media.licdn.com\/.+$/i;
const LINKEDIN_PROFILE_URL_OR_EMPTY_REGEX = /^$|((https:\/\/)?(\S{2,4}\.)?linkedin.com\/in\/([^?/\s]+)[/]?)$/i;
function isValidLinkedinImageUrl(url) {
    const isValid = LINKEDIN_IMAGE_URL_REGEX.test(url);
    return isValid;
}
function isValidLinkedinUrl(url) {
    const isValid = LINKEDIN_PROFILE_URL_REGEX.test(url);
    return isValid;
}
function getLinkedinUsernameFromUrl(url) {
    const matches = LINKEDIN_PROFILE_URL_REGEX.exec(url);
    if (!matches || matches.length < 4 || !matches[3]) {
        throw new Error(`[getLinkedinUsernameFromUrl] error retrieving username from url: ${url}`);
    }
    const username = (matches[3] || '').replace('/', '');
    return username;
}
//# sourceMappingURL=linkedin-utils.js.map
;// CONCATENATED MODULE: ../utils/dist/esm/index.js







//# sourceMappingURL=index.js.map

/***/ }),

/***/ 57982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ f; },
/* harmony export */   "M": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63955);
var e=function(i,e,t){if(i&&"reportValidity"in i){var f=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)(t,e);i.setCustomValidity(f&&f.message||""),i.reportValidity()}},t=function(r,i){var t=function(t){var f=i.fields[t];f&&f.ref&&"reportValidity"in f.ref?e(f.ref,t,r):f.refs&&f.refs.forEach(function(i){return e(i,t,r)})};for(var f in i.fields)t(f)},f=function(e,f){f.shouldUseNativeValidation&&t(e,f);var o={};for(var a in e){var n=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)(f.fields,a);(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .set */ .t8)(o,a,Object.assign(e[a]||{},{ref:n&&n.ref}))}return o};
//# sourceMappingURL=resolvers.module.js.map


/***/ }),

/***/ 33161:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63955);
/* harmony import */ var _hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57982);
var n=function(e,o){for(var n={};e.length;){var t=e[0],s=t.code,i=t.message,a=t.path.join(".");if(!n[a])if("unionErrors"in t){var u=t.unionErrors[0].errors[0];n[a]={message:u.message,type:u.code}}else n[a]={message:i,type:s};if("unionErrors"in t&&t.unionErrors.forEach(function(r){return r.errors.forEach(function(r){return e.push(r)})}),o){var c=n[a].types,f=c&&c[t.code];n[a]=(0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .appendErrors */ .KN)(a,o,n,s,f?[].concat(f,t.message):t.message)}e.shift()}return n},t=function(r,t,s){return void 0===s&&(s={}),function(i,a,u){try{return Promise.resolve(function(o,n){try{var a=Promise.resolve(r["sync"===s.mode?"parse":"parseAsync"](i,t)).then(function(r){return u.shouldUseNativeValidation&&(0,_hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__/* .validateFieldsNatively */ .M)({},u),{errors:{},values:s.raw?i:r}})}catch(r){return n(r)}return a&&a.then?a.then(void 0,n):a}(0,function(r){if(function(r){return null!=r.errors}(r))return{values:{},errors:(0,_hookform_resolvers__WEBPACK_IMPORTED_MODULE_1__/* .toNestError */ .D)(n(r.errors,!u.shouldUseNativeValidation&&"all"===u.criteriaMode),u)};throw r}))}catch(r){return Promise.reject(r)}}};
//# sourceMappingURL=zod.module.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,3955,625,4882,2987,9774,2888,179], function() { return __webpack_exec__(18919); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);